<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-2">{{ $t("cash_card_transactions") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- Transaction Date From-->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="from_date"
                  v-on:click="clearDate('from_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @selected="onchangeDate($event, 'from')"
                ></Datepicker>
                <label :class="from_date ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Transaction Date To -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                ></Datepicker>
                <label :class="to_date ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="statusArray"
                  v-model="selectedStatusObj"
                  :placeholder="'Select Status'"
                  label="statusName"
                  track-by="statusName"
                  @select="onSelectFilter($event)"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="getCardTransactions"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div class="row mb-3">
          <div class="col-xl-3">
            <b-form-input
              v-model="searchValue"
              v-debounce:800="onSearch"
              placeholder="Search..."
            ></b-form-input>
          </div>

          <!--Color Code--->
          <div
            class="color-coding col-xl-5 d-flex justify-content-start align-self-center"
            v-if="updateStatusArray.length > 0"
            style="width: 100%"
          >
            <div
              class="pr-2"
              v-for="(type, typeIndex) in updateStatusArray"
              :key="typeIndex"
            >
              <div class="d-flex">
                <div class="col-1">
                  <div
                    class="color-box"
                    :style="'background-color:' + type.colorCode"
                  ></div>
                </div>
                <div class="col-10 color-combination">
                  {{ type.statusName }}
                </div>
              </div>
            </div>
          </div>
          <!--Color Code--->

          <div class="col-xl-4 d-flex justify-content-between">
            <div class="mr-2">
              <b-dropdown id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div
              v-if="cardList.length > 0"
              class="d-flex justify-content-end align-items-center"
            >
              <div class="mr-2">{{ $t("download") }} as:</div>
              <a
                :href="
                  BASE_URL +
                  `/api/admin/export_cash_cards_transaction${queryString}`
                "
                target="_blank"
                title="Download as Excel"
                download
              >
                <img
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>

        <div class="swc-report">
          <table class="swc-report-table mb-3" border="1">
            <thead style="background-color: #f5f5f7">
              <tr class="bg-lightgrey">
                <th>{{ $t("transaction_id") }}</th>
                <th>{{ $t("card_status") }}</th>
                <th>
                  {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
                </th>
                <th>{{ $t("delivery_date") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("phone") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                <th>{{ "Is Guest User" }}</th>

                <th>{{ $t("issuer") }}</th>
                <th>{{ $t("quantity") }}</th>
                <th>
                  {{ $t("amounts") }} <br />
                  <span style="font-size: 11px"> (per card)</span>
                </th>
                <th>
                  {{ $t("w_professing_fee") }} <br />
                  <span style="font-size: 11px"> (per card)</span>
                </th>
                <th>{{ $t("totalamount") }}</th>
                <th>{{ $t("view") }} {{ $t("more") }}</th>
                <th>{{ $t("view") }} {{ $t("logs") }}</th>
                <th>{{ $t("action") }}</th>
              </tr>
            </thead>
            <tbody
              v-for="(card, cardIndex) in cardList"
              :key="cardIndex"
              class="sph-report light_grey_back"
            >
              <tr>
                <td class="text-right">{{ card.reservation_id || "-" }}</td>
                <td :style="'color:' + card.color_code" class="text-left">
                  {{ card.status }}
                </td>
                <td class="text-right">
                  {{ card.created_at | fulldatemonparse }}
                </td>
                <td class="text-right">{{ card.date_issue_card }}</td>
                <td class="text-left">
                  {{ card.customer_first_name }}
                  {{
                    card.customer_last_name ? " " + card.customer_last_name : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    card.customer_mobile && card.customer_mobile_code
                      ? "+" + card.customer_mobile_code + " "
                      : ""
                  }}
                  {{ card.customer_mobile || "-" }}
                </td>
                <td class="text-left">{{ card.customer_email || "-" }}</td>
                <td>{{ card.is_guest_user }}</td>
                <td class="text-left">{{ card.w_issuer_name }}</td>
                <td class="text-right">{{ card.quantity }}</td>
                <td class="text-right">{{ currFormat(card.topup_amount) }}</td>
                <td class="text-right">
                  {{ currFormat(card.processing_fee) }}
                </td>
                <td class="text-right">{{ currFormat(card.total_amount) }}</td>
                <td>
                  <button @click="onClickViewMore(card)" class="btn-blue">
                    View More
                  </button>
                </td>
                <td>
                  <button
                    class="btn-transparent"
                    @click="onClickViewLogs(card)"
                  >
                    <img
                      src="@/assets/img/icons/view.png"
                      alt="View File"
                      @click="showFile(macsValue)"
                    />
                  </button>
                </td>
                <td>
                  <button
                    class="btn-transparent"
                    @click="onClickUpdateStatus(card)"
                  >
                    <img
                      src="@/assets/img/icons/primary/edit.svg"
                      height="20"
                      width="20"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-if="cardList.length == 0">
              <tr>
                <td colspan="16">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <br />

      <b-pagination
        v-if="cardList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <b-modal
      id="viewmorecarddetails"
      ref="viewmorecarddetails"
      title="Card Details"
      hide-footer
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-6">Name (as on card):</div>
              <div class="col-6">
                <strong>{{ transactionSelected.name_on_card || "-" }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-6">Email:</div>
              <div class="col-6">
                <strong>{{ transactionSelected.email || "-" }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-6">Address:</div>
              <div class="col-6">
                <strong>{{ transactionSelected.address || "-" }}</strong>
              </div>
            </div>
          </div>
          <div
            class="col-12 border-bottom py-2"
            v-if="transactionSelected.is_gift_card == 'Y'"
          >
            <div class="row">
              <div class="col-6">Special Message:</div>
              <div class="col-6">
                <strong>{{ transactionSelected.specialMessage || "-" }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-6">Estimated Delivery Date:</div>
              <div class="col-6">
                <strong>{{
                  transactionSelected.date_issue_card || "-"
                }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-6">Card Type:</div>
              <div class="col-6">
                <strong>{{
                  transactionSelected.is_gift_card == "Y"
                    ? "Gift Card"
                    : "Personal Card"
                }}</strong>
              </div>
            </div>
          </div>
          <div
            class="col-12 border-bottom py-2"
            v-for="(c_card, c_index) in transactionSelected.cardArray"
            :key="c_index"
          >
            <div class="row">
              <div class="col-6">Card Number {{ c_index + 1 }}:</div>
              <div class="col-6">
                <strong class="fw-ms"
                  >{{ c_card.cash_card_number
                  }}<span>
                    <button
                      class="btn-transparent"
                      @click="
                        $router.push({
                          name: 'Edit Cash Card',
                          params: { cash_card_id: c_card.cash_card_id },
                        })
                      "
                    >
                      <img
                        src="@/assets/img/icons/open-link-blue.svg"
                        height="20"
                        width="20"
                        style="margin-bottom: 5px"
                      />
                    </button> </span
                ></strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="viewStatusLogs"
      ref="viewStatusLogs"
      title="Status Logs"
      hide-footer
      size="lg"
    >
      <div>
        <div class="row mx-0">
          <div class="col-7 mb-4">
            <div class="row mb-2">
              <div class="col-6">{{ "Transaction ID" }}</div>
              <div class="col-6 font-weight-bold">
                {{ logDetailsObj.reservation_id || "-" }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">{{ "Current Status" }}</div>
              <div
                class="col-6 font-weight-bold"
                :style="'color:' + logDetailsObj.color_code"
              >
                {{ logDetailsObj.status || "-" }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">{{ "Created At" }}</div>
              <div class="col-6 font-weight-bold">
                {{ logDetailsObj.created_at | dateFormat }}
              </div>
            </div>
          </div>
          <table class="swc-report-table mb-3" border="1">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>{{ "Previous Status" }}</th>
                <th>{{ "Changed Status" }}</th>
                <th>{{ "Date" }}</th>
                <th>{{ "Time" }}</th>
                <th>{{ "Remarks" }}</th>
                <th>{{ "Updated By" }}</th>
              </tr>
            </thead>
            <template v-if="logsArray.length > 0">
              <tbody>
                <tr v-for="(log, logIndex) in logsArray" :key="logIndex">
                  <td>{{ logIndex + 1 }}</td>
                  <td>{{ log.status_from }}</td>
                  <td>{{ log.status_to }}</td>
                  <td>{{ log.created_at | dateFormat }}</td>
                  <td>{{ log.created_at | time }}</td>
                  <td>{{ log.description }}</td>
                  <td>{{ log.username }}</td>
                </tr>
              </tbody>
            </template>
            <tbody v-else>
              <td colspan="7">
                <NoRecords />
              </td>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="updateStatusModal"
      ref="updateStatusModal"
      title="Update Status"
      hide-footer
    >
      <div class="row px-5">
        <div class="col-lg-12 mb-3">
          <multiselect
            v-model="cardStatusObj"
            placeholder="Select status"
            track-by="statusName"
            label="statusName"
            :options="updateStatusArray"
            @select="onSelectUpdateStatus($event)"
            name="cardstatus"
            id="cardstatus"
          ></multiselect>
        </div>

        <div class="col-lg-12 mb-3">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="description"
                name="description"
                v-model="card_description"
                placeholder="Enter Remarks"
                type="text"
              />
              <label>{{ $t("remarks") }}</label>
            </div>
          </div>
        </div>
        <button
          :disabled="!selectedUpdateStatus"
          class="btn btn-blue w-100 px-2"
          @click.prevent.stop="updateCardStatus()"
        >
          Update Status
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import PosService from "@/services/PosService";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";
import MarketingService from "@/services/MarketingService";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      logDetailsObj: {
        reservation_id: "",
        status: "",
        created_at: "",
        color_code: "",
      },
      logsArray: [],
      selectedCardTransaction: null,
      card_description: "",
      selectedUpdateStatus: "",
      statusArray: [],
      cardStatusObj: "",
      selectedStatus: "Pending",
      selectedStatusObj: {
        id: 1,
        statusName: "Pending",
      },
      transactionSelected: {
        name_on_card: "",
        email: "",
        specialMessage: "",
        address: "",
        date_issue_card: "",
        is_gift_card: "",
        cardArray: [],
      },
      from_date: moment().toDate(),
      to_date: new Date(),
      cinema_id: null,
      statuses: [
        {
          id: 1,
          status: "Pending",
        },
        {
          id: 2,
          status: "Ready",
        },
        {
          id: 3,
          status: "Dispatched",
        },
        {
          id: 3,
          status: "Deliver",
        },
      ],
      cardList: [],
      searchValue: "",
      btenable: false,
      isSearchLoading: false,
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
    };
  },
  beforeMount() {
    this.getCardTransactions();
    this.getviewingnumber();
  },
  watch: {},
  computed: {
    updateStatusArray() {
      return this.statusArray.filter((x) => x.statusName !== "All");
    },
    queryString() {
      let queryString = ``;
      let obj = {
        is_space: "N",
        from_date: this.from_date
          ? moment(this.from_date).format("YYYY-MM-DD")
          : "",
        to_date: this.to_date ? moment(this.to_date).format("YYYY-MM-DD") : "",
      };
      queryString = this.createQueryString(obj);
      return queryString;
    },
  },
  methods: {
    createQueryString,
    onSearch() {
      this.currentPage = 1;
      this.getCardTransactions();
    },
    onClickViewLogs(card) {
      this.logsArray = card.status_logs;
      Object.keys(this.logDetailsObj).map((x) => {
        this.logDetailsObj[x] = card[x];
      });
      this.$refs.viewStatusLogs.show();
    },
    onSelectUpdateStatus(status) {
      this.selectedUpdateStatus = status.statusName;
    },
    updateCardStatus() {
      if (!this.selectedUpdateStatus) {
        return this.$toasted.show("Please Select Card Status");
      } else {
        let payload = {
          reservation_id: this.selectedCardTransaction.reservation_id,
          status_from: this.selectedCardTransaction.status,
          status_to: this.selectedUpdateStatus,
          description: this.card_description,
        };
        MarketingService.UpdateCardStatus(payload)
          .then((response) => {
            const { data } = response;
            console.log(data);
            if (data && data.status) {
              this.$refs.updateStatusModal.hide();
              this.$toasted.show(data.message);
              this.getCardTransactions();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    onSelectFilter(filter) {
      this.selectedStatus = filter.statusName;
      this.getCardTransactions();
    },
    onClickUpdateStatus(card) {
      this.selectedCardTransaction = card;
      this.cardStatusObj = this.updateStatusArray.filter(
        (x) => x.statusName == card.status
      );
      if (this.cardStatusObj) {
        this.$refs.updateStatusModal.show();
      }
    },
    onClickViewMore(card) {
      let receipeint_detail = card.receipeint_detail;
      receipeint_detail["cardArray"] = card.cash_card_obj;
      Object.keys(this.transactionSelected).map((x) => {
        this.transactionSelected[x] = receipeint_detail[x];
      });
      this.$refs.viewmorecarddetails.show();
      console.log("card", card);
    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCardTransactions();
      } else {
        this.currentPage = event;
        this.getCardTransactions();
      }
    },
    clearDate(type) {
      this.currentPage = 1;
      this.cardList = [];
      switch (type) {
        case 1:
        case "from_date":
          this.from_date = "";
          break;
        case 2:
        case "to_date":
          this.to_date = "";
          break;
      }
    },
    debouncedOnChange: _.debounce(function (query) {
      this.cardList = [];
      this.currentPage = 1;
      this.getCardTransactions();
    }, 500),
    onchangeDate: function (event, type) {
      if (type == "from") {
        this.to_date = new Date(event);
        this.$forceUpdate();
      }
      this.debouncedOnChange();
    },
    getCardTransactions: function () {
      if (this.to_date && !this.from_date) {
        return this.$toasted.show("Please select From date");
      } else if (this.from_date && !this.to_date) {
        return this.$toasted.show("Please select TO date");
      } else if (moment(this.from_date).isAfter(this.to_date)) {
        return this.$toasted.show("From must be smaller than To Date");
      } else {
        let loader = this.$loading.show();
        this.cardList = [];
        this.btenable = true;
        let payload = {
          fromDate: this.from_date
            ? moment(this.from_date).format("YYYY-MM-DD")
            : null,
          toDate: this.to_date
            ? moment(this.to_date).format("YYYY-MM-DD")
            : null,
          searchValue: this.searchValue,
          status: this.selectedStatus,
          limit: this.perPage,
          currentPage: this.currentPage,
        };

        MarketingService.GetCashCardTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.statusArray) {
              this.statusArray = data.statusArray;
            }
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.cardList = data.Records;
              if (data.pagination.total) {
                this.rows = data.pagination.total;
              }
              this.selectedvalue = data.pagination.to - data.pagination.from;
            } else {
              this.cardList = [];
              this.selectedvalue = 0;
              this.rows = 0;
              this.$toasted.show(this.$t("No Records Found"));
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            this.btenable = false;
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.color-box {
  width: 15px;
  height: 15px;
  margin-bottom: 10px;
}
.color-combination {
  font-size: 12px;
}

.fw-ms {
  font-family: Arial !important;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardComponents/onlineCashCardReport.vue